import { AppData, PluginData } from 'app/console-api/offers/offers-extended';
import { PaginationResponseType, Task } from 'app/console-api';
import { PaginationParams } from 'app/console-api/utils/pagination';
import { AUTH_TOKEN } from 'app/constants';
import { HttpError } from 'app/components/utils/http-error';
import { RewardsValue } from 'app/console-api/apps/types';
import { UrlFilterController } from 'app/components/filters/url-filters';
import { TaskTypeAdapter } from 'app/components/filters/task-type-filter';
import { CategoriesAdapter } from 'app/components/filters/categories-filter';
import { AutomationRequest } from 'app/console-api/automations/types';
import { TaskStatusAdapter } from 'app/components/filters/task-status-filter';

export interface TaskStatistics {
  claimsDaily: number;
  claimsMonthly: number;
}

export interface ExtendedTasksResponse {
  task: Task;
  app: AppData;
  plugin: PluginData;
  statistics: TaskStatistics;
  categories: string[];
  rewards: RewardsValue[];
  automations: AutomationRequest[];
}

export const getExtendedTasks = async (
  appID: string,
  ctl?: UrlFilterController,
  pagination?: PaginationParams
): Promise<PaginationResponseType<ExtendedTasksResponse>> => {
  let params = new URLSearchParams();
  if (ctl) {
    params = ctl.buildSearchParams([
      { adapter: TaskStatusAdapter, value: ctl.get(TaskStatusAdapter) },
      { adapter: TaskTypeAdapter, value: ctl.get(TaskTypeAdapter) },
      { adapter: CategoriesAdapter, value: ctl.get(CategoriesAdapter) }
    ]);
  }
  if (!pagination) {
    const pageSize: number = Number(process.env.REACT_APP_PAGE_SIZE_ITEMS);
    pagination = { pageSize, currentPage: 1 };
  }
  params.append('pageSize', pagination?.pageSize.toString());
  params.append('currentPage', pagination?.currentPage.toString());

  const response = await fetch(
    `${process.env.REACT_APP_TRAFFIC_EXCHANGE_CONSOLE_API_URL}/apps/${appID}/tasks?${params.toString()}`,
    {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN) || ''}`
      }
    }
  );

  if (!response.ok) {
    return Promise.reject(
      new HttpError(`Failed to get tasks: ${response.statusText}`, response.status)
    );
  }

  return response.json();
};
